import { makeStyles } from '@material-ui/styles'
import CodeBlock from 'core/components/CodeBlock'
import Button from 'core/elements/button/Button'
import Modal from 'core/elements/modal/Modal'
import Theme from 'core/themes/model'
import React, { useEffect, useCallback, useState } from 'react'

const useStyles = makeStyles<Theme>((theme) => ({
  errorBlock: {
    color: 'red',
    backgroundColor: '#fcebeb',
  },
}))

interface ErrorDialogProps {
  volume: any
  onClose: () => void
}

const VolumeErrorModal = ({ volume, onClose }: ErrorDialogProps) => {
  const classes = useStyles()
  const [copied, setCopied] = useState(false)

  const handleClose = useCallback(() => {
    onClose()
    setCopied(false)
  }, [onClose])

  // Close on Esc
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleClose()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [handleClose])

  const handleErrorCopy = useCallback(() => {
    navigator.clipboard.writeText(volume?.message?.user_message)
    setCopied(true)
  }, [volume])

  return (
    <Modal
      title="Volume Error Details"
      onClose={handleClose}
      maxWidth={1000}
      panel="dialog"
      footer={
        <>
          {volume?.message?.user_message && (
            <Button variant="secondary" onClick={handleErrorCopy}>
              {copied ? 'Copied!' : 'Copy'}
            </Button>
          )}
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </>
      }
      open
    >
      {volume?.message?.user_message ? (
        <CodeBlock className={classes.errorBlock}>{volume?.message?.user_message}</CodeBlock>
      ) : (
        <CodeBlock className={classes.errorBlock}>
          No error details are available for this volume
        </CodeBlock>
      )}
    </Modal>
  )
}

export default VolumeErrorModal
